import React from 'react';

const LanguagePicker = () => {
  return (
    <div
      className="dropdown"
      style={{
        position: 'fixed', 
        top: '20px',
        right: '20px',
        zIndex: 1050, 
      }}
    >
      <button
        className="btn btn-light dropdown-toggle"
        type="button"
        id="languageDropdown"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        style={{
          padding: '10px 20px',
          fontSize: '14px', 
        }}
      >
        Türkçe
      </button>
      <ul
        className="dropdown-menu dropdown-menu-end"
        aria-labelledby="languageDropdown"
        style={{
          minWidth: '150px', 
          fontSize: '14px',
        }}
      >
        <li>
          <a className="dropdown-item" href="#">
            Türkçe
          </a>
        </li>
        {/* <li>
          <a className="dropdown-item" href="#">
            English
          </a>
        </li>
        <li>
          <a className="dropdown-item" href="#">
            Français
          </a>
        </li> */}
      </ul>
    </div>
  );
};

export default LanguagePicker;
